import { useEffect, useState } from 'react';
import { Alert, Box, LinearProgress } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { setOfflineListener } from '../../api/client';

export function BackendHealthBanner() {
  const [offline, setOffline] = useState(false);
  const qc = useQueryClient();

  useEffect(() => {
    setOfflineListener(() => setOffline(true));
    return () => setOfflineListener(null);
  }, []);

  useEffect(() => {
    if (!offline) return;
    const poll = setInterval(async () => {
      try {
        const res = await fetch('/api/health');
        if (res.ok) {
          setOffline(false);
          void qc.invalidateQueries();
        }
      } catch {
        // still down
      }
    }, 3000);
    return () => clearInterval(poll);
  }, [offline, qc]);

  if (!offline) return null;

  return (
    <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 2000 }}>
      <Alert severity="warning" sx={{ borderRadius: 0, py: 0.5 }}>
        Server is starting up — reconnecting…
      </Alert>
      <LinearProgress color="warning" />
    </Box>
  );
}
